(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 701px)');
  let reveal, visible, frame = 0;
  const scenes = new Set();
  const inView = new Set();
  const finish = () => {
    document.querySelectorAll('.hh-hero-video video').forEach(video => video.pause());
    document.querySelectorAll('[data-hh-reveal]').forEach(el => el.getAnimations().forEach(a => a.finish()));
    scenes.forEach(el => { el.style.setProperty('--hh-shift', '0px'); el.style.setProperty('--hh-open', '0'); });
  };
  const paint = () => {
    frame = 0;
    if (reduced.matches || !desktop.matches) return;
    inView.forEach(el => {
      const rect = el.getBoundingClientRect();
      const offset = Math.max(-12, Math.min(12, (innerHeight / 2 - rect.top - rect.height / 2) * .035));
      el.style.setProperty('--hh-shift', offset.toFixed(2) + 'px');
      if (el.classList.contains('hh-signature')) {
        const progress = Math.max(0, Math.min(1, (innerHeight - rect.top) / (innerHeight + rect.height)));
        el.style.setProperty('--hh-open', progress.toFixed(3));
      }
    });
  };
  const scroll = () => { if (!frame && inView.size) frame = requestAnimationFrame(paint); };
  const init = (root = document) => {
    root.querySelectorAll('.hh-hero-video video').forEach(video => { if (reduced.matches) video.pause(); });
    root.querySelectorAll('[data-hh-reveal]').forEach(el => {
      if (el.dataset.hhSeen || el.closest('[data-hh-motion="false"]')) return;
      if (reduced.matches || window.Shopify?.designMode) return;
      reveal?.observe(el);
    });
    root.querySelectorAll('[data-hh-hero][data-hh-motion="true"],.hh-signature[data-hh-motion="true"]').forEach(el => {
      scenes.add(el);
      if (!reduced.matches && !window.Shopify?.designMode) visible?.observe(el);
    });
  };
  if ('IntersectionObserver' in window) {
    reveal = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      el.dataset.hhSeen = 'true';
      reveal.unobserve(el);
      if (!reduced.matches && typeof el.animate === 'function') {
        el.animate([{ opacity: .5, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 620, easing: 'cubic-bezier(.2,.7,.2,1)' });
      }
    }), { threshold: .08 });
    visible = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? inView.add(entry.target) : inView.delete(entry.target));
      scroll();
    }, { rootMargin: '120px' });
  }
  init();
  window.addEventListener('scroll', scroll, { passive: true });
  window.addEventListener('resize', () => { if (!desktop.matches) finish(); else scroll(); }, { passive: true });
  reduced.addEventListener('change', () => { if (reduced.matches) finish(); else init(); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    scenes.forEach(el => {
      if (event.target.contains(el)) { scenes.delete(el); inView.delete(el); visible?.unobserve(el); }
    });
    event.target.querySelectorAll('[data-hh-reveal]').forEach(el => reveal?.unobserve(el));
  });
})();
